/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Member_SinceInputs */

const en_us2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Member since ${i?.date}`)
};

const pt_br2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membro desde ${i?.date}`)
};

const es_419_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miembro desde ${i?.date}`)
};

const pt_pt2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membro desde ${i?.date}`)
};

const fr_fr2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membre depuis ${i?.date}`)
};

const de_de2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mitglied seit ${i?.date}`)
};

const it_it2_profile_member_since = /** @type {(inputs: Profile_Member_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membro dal ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Member since {date}" |
*
* @param {Profile_Member_SinceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_member_since = /** @type {((inputs: Profile_Member_SinceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Member_SinceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_member_since(inputs)
	if (locale === "es-419") return es_419_profile_member_since(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_member_since(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_member_since(inputs)
	if (locale === "de-DE") return de_de2_profile_member_since(inputs)
	if (locale === "it-IT") return it_it2_profile_member_since(inputs)
	return en_us2_profile_member_since(inputs)
});
export { profile_member_since as "profile.member_since" }